import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { ChartOfAccountDetailsEntity } from '../../../../api/types/settings/accounting/chart-of-accounts/chart-of-account-details.type';

export const getChartOfAccountsOperation = async (
  setLoading: (loading: boolean) => void,
  setData: (data: ChartOfAccountDetailsEntity[]) => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.getChartOfAccountsList();
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setData([]);
      return;
    }
    setData(res.data.body || []);
  } catch (error) {
    console.error('getChartOfAccountsOperation failed:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setData([]);
    throw error;
  } finally {
    setLoading(false);
  }
};
